// extracted by mini-css-extract-plugin
export default {"container":"style__container--ICNI3","link-column":"style__link-column--MjiJm","linkColumn":"style__link-column--MjiJm"};